<po-widget class="po-lg-12 po-mb-1" *ngFor="let item of myData; let i = index">
  <div class="po-row po-pb-1" style="border-bottom: 1px solid #d3d3d3; margin-bottom: 5px;">
    <div class="po-xl-11 po-lg-11 po-md-11 po-sm-11">
      <div class="po-row">
        <div class="po-xl-6 po-lg-6 po-md-6 po-sm-7">
          <span class="po-text-color-01 po-font-text-large-bold" [ngClass]="{ 'text-red': switchRemove }">Código: </span>
          <span class="po-ml-1 po-font-text-large">{{ item.productCode }}</span>
        </div>
        <div class="po-xl-6 po-lg-6 po-md-6 po-sm-5 po-text-center">
          <span class="po-text-color-01 po-font-text-large-bold" [ngClass]="{ 'text-red': switchRemove }">Qtd.: </span>
          <span class="po-ml-1 po-font-text-large">{{ item.quantity }}</span>
        </div>
      </div>
      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <span class="po-text-color-01 po-font-text-large-bold" [ngClass]="{ 'text-red': switchRemove }">Produto: </span>
          <span class="po-ml-1 po-font-text-large">{{ item.productName }}</span>
        </div>
      </div>
      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <span class="po-text-color-01 po-font-text-large-bold" [ngClass]="{ 'text-red': switchRemove }">Cor: </span>
          <span class="po-ml-1 po-font-text-large">{{ item.productColor }}</span>
        </div>
      </div>
    </div>
    <div class="po-xl-1 po-lg-1 po-md-1 po-sm-1 po-text-right">
      <span class="po-text-color-01 po-font-text-large-bold" style="cursor: pointer;" (click)="seeDescriptionItens(item)">
        <i *ngIf="!item.expanded" class="an-fill an-caret-circle-up" style="font-size: 20px;"></i>
        <i *ngIf="item.expanded" class="an-fill an-caret-circle-down" style="font-size: 20px;"></i>
      </span>
    </div>
  </div>
  <div class="po-row" *ngIf="item.expanded">
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12" *ngFor="let itemCodBar of item.productSkus">
      <span class="po-text-color-01 po-font-text-large-bold"><i class="an an-check-fat"></i></span>
      <span class="po-ml-1 po-font-text-large">{{ itemCodBar.productSku }}</span>
    </div>
  </div>
</po-widget>